
import styled, { css } from 'styled-components';

const ModelViewerWrapper = () => css`
    position: relative;
    background: #FFFFFF;
    border-radius: 24px;
    height: 100%;
    width: 100%;
    &:focus{
            outline:none;
            }
`;


export default styled.div([ModelViewerWrapper]);